export const TIMELINE_CONTENT_WRAPPER_ID = 'timeline-content-wrapper'
export const TIMELINE_RULER_HEIGHT = 40
